import RestService from "./restService";
import { STAGES } from "../../url/hiring";
const singleton = Symbol();
const singletonEnforcer = Symbol();
/**
 *
 */
class StagesService extends RestService {
  constructor(enforcer) {
    super(STAGES);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct Agency RestService more than one");
  }
  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new StagesService(singletonEnforcer);
    }
    return this[singleton];
  }
}

export default StagesService;
